import React, { useEffect, useState, useRef, useContext } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import VideoPlayer from "../../components/videoplayer/VideoPlayer";
import Select from "../../components/select/Select";
import MultiSelect from "../../components/multiselect/MultiSelect";
import Delete from "../../components/delete/Delete";
import Breadcrumbs from "../../components/breadcrumbs/Breadcrumbs";
import "./ExerciseBuilder.css";
import ExerciseBuilderModal from "../../components/programDetailModals/ExerciseBuilderModal";
import { Context } from "../../context/Context";
import ExerciseActivity from "./ExerciseActivity";

let hasTasks = false;

const ExerciseBuilder = (props) => {
  let { task_id } = useParams();
  let { dayInx } = useParams();
  let { taskInx } = useParams();
  const navigate = useNavigate();

  const {saveExerciseBuilder, setSaveExerciseBuilder} = useContext(Context);

  
  // ------------------------- CHECK IF TASK STARTED BY PATIENT -------------------------------
  
  // GO BACK IF CURRENT TASK IS STARTED BY PATIENT
  async function fetchTaskStatus(){
    let dayData = JSON.parse(localStorage.getItem("programDataEdit"))?.day_data
    if(!dayData?.length) return;
    let taskID = dayData[dayInx]?.tasks_arr[taskInx]?.task_id;
    if(taskID){
    try {
      axios.defaults.headers.common["Authorization"] = JSON.parse(
        localStorage.getItem("userData")
      ).token;
      axios
        .post(window.ajaxLink + "cloud_programs/checkTaskActivityStatus", {
          taskIds: [taskID],
        })
        .then((res) => {
          if(res?.status === 200){
            let response = res?.data?.responseData[0];
            if(response?.start_date && response?.start_date !== null){
              fromExerBuilder(localStorage.getItem("taskBuilderType"));
              localStorage.removeItem("ExerBuilderEdited");
              localStorage.setItem("showPatientEditingAlert", true)
            };
          }
        })
        .catch((error) => {
          console.error(error);
        });
    } catch (error) {
      console.error("Error fetching task statuses:", error);
    }
  }
  }

  useEffect(() => {
    if(dayInx && taskInx){
      fetchTaskStatus();

      // SSE TO RE-FETCH TASKS STATUS WHEN CHANGED REALTIME
      let programId = localStorage.getItem("programIdEdit");
        if(programId){
          const eventSource = new EventSource(
            window.ajaxLink +
              "updatesse/events?observeData=programEditListen&valueName=" +
              programId
          );
          eventSource.onmessage = (e) => {
            if (e.data.toString().toLowerCase() == "update") {
              fetchTaskStatus();
            }
          };
          return () => {
            eventSource.close();
          };
        }
    }
  }, [dayInx, taskInx])

  // ------------------------- CHECK IF TASK STARTED BY PATIENT -------------------------------



  useEffect(() => {
    localStorage.setItem("taskBuilder", "true");
  }, []);

  useEffect(() => {
    window.onbeforeunload = function (e) {
      e.preventDefault();
      return "Save unsaved changes?";
    };
  }, []);

  useEffect(() => {
    localStorage.removeItem("ExerBuilderEdited");
  }, []);

  const [workoutName, setWorkoutName] = useState("");
  const [workoutDesc, setWorkoutDesc] = useState("");
  const [workoutLevel, setWorkoutLevel] = useState("");
  const [workoutRom, setWorkoutRom] = useState("0%");
  const [workoutDuration, setWorkoutDuration] = useState("");

  const [workoutNameCopy, setWorkoutNameCopy] = useState("");
  const [workoutDescCopy, setWorkoutDescCopy] = useState("");
  const [workoutLevelCopy, setWorkoutLevelCopy] = useState("");
  const [workoutRomCopy, setWorkoutRomCopy] = useState("0%");
  // eslint-disable-next-line
  const [workoutDurationCopy, setWorkoutDurationCopy] = useState("");
  // eslint-disable-next-line
  const updateWorkoutLevel = (callVal, value) => {
    callVal(value);
  };

  const [activityPool, setActivityPool] = useState([]);
  const [activityPoolCopy, setActivityPoolCopy] = useState("");
  //const [virtualActs, setVirtualActs] = useState([]);
  // eslint-disable-next-line
  const [sendBackParam, setSendBackParam] = useState(0);
  const [programId] = useState(
    localStorage.getItem("programIdEdit")
      ? localStorage.getItem("programIdEdit")
      : ""
  );

  /* const [taskLevels] = useState([
    { value: "Beginner" },
    { value: "Basic" },
    { value: "Pre-Intermediate" },
    { value: "Intermediate" },
    { value: "Intermediate-High" },
    { value: "Advanced" },
  ]); */

  //const [durationTypes] = useState([{ value: "Reps" }, { value: "Time" }]);

  useEffect(() => {
    props.actSidebar(false);
    // window.onbeforeunload = null;
    var userData = JSON.parse(localStorage.getItem("userData"));
    if (userData === null) {
      props.checkLoggedIn(false);
    } else {
      /* axios.defaults.headers.common["Authorization"] = JSON.parse(localStorage.getItem("userData")).token;
      axios
        .post(window.ajaxLink + "cloud_programs/task-activities", { task_id })
        .then((res) => {
          if (res.data.responseData) {
            let response = res.data.responseData; */
      let storage = JSON.parse(localStorage.getItem("new_tasks"))
        ? JSON.parse(localStorage.getItem("new_tasks")).filter(
            (obj) => obj.dayInx === dayInx && obj.taskInx === taskInx
          )[0]
        : "";
      let existingTask = JSON.parse(localStorage.getItem("new_program"))
        ? JSON.parse(localStorage.getItem("new_program")).day_data[dayInx]
            .tasks_arr[taskInx]
        : "";
      setWorkoutName(
        storage && storage.workoutName
          ? storage.workoutName
          : existingTask && existingTask.task_name
          ? existingTask.task_name
          : (localStorage.getItem("exerBuilderTaskType") ? 'Range of Motion Test' : '')
      );
      setWorkoutDesc(
        existingTask && existingTask.description
          ? existingTask.description
          : storage && storage.workoutDesc
          ? storage.workoutDesc
          : ""
      );
      setActivityPool(
        existingTask && existingTask.activity_data
          ? existingTask.activity_data
          : storage && storage.activityPool
          ? storage.activityPool
          : []
      );
      setWorkoutLevel(
        existingTask && existingTask.level
          ? existingTask.level
          : storage && storage.workoutLevel
          ? storage.workoutLevel
          : ""
      );
      setWorkoutDuration(
        existingTask && existingTask.duration
          ? existingTask.duration
          : storage && storage.workoutDuration
          ? storage.workoutDuration
          : ""
      );
      setWorkoutNameCopy(
        existingTask && existingTask.task_name
          ? existingTask.task_name
          : storage && storage.workoutName
          ? storage.workoutName
          : ""
      );
      if (storage) {
        setWorkoutDesc(storage.workoutDesc);
        setWorkoutLevel(storage.workoutLevel);
        setWorkoutRom(storage.workoutRom);
        setWorkoutDuration(storage.workoutDuration);
        setActivityPool(storage.activityPool);

        setWorkoutDescCopy(storage.workoutDesc);
        setWorkoutLevelCopy(storage.workoutLevel);
        setWorkoutRomCopy(storage.workoutRom);
        setWorkoutDurationCopy(storage.workoutDuration);
        setActivityPoolCopy(JSON.stringify(storage.activityPool));
        if (!!task_id) {
          setSendBackParam(
            localStorage.getItem("programIdEdit")
              ? localStorage.getItem("programIdEdit")
              : ""
          );
        }
      }
	  
	  
      //setVirtualActs(response.virtual_activities);
      setExrPage(document.getElementById("exr_bld"));
      /* }
        })
        .catch((error) => {
          console.log(error);
          if (error.response.data.responseCode === 400 || error.response.data.responseCode === 401) {
            props.checkLoggedIn(false);
          }
        }); */
    }
  }, [props, task_id, dayInx, taskInx]);

  const [exrPage, setExrPage] = useState({});
  const [wrapMarg] = useState(10);

  const [useSearch, setUseSearch] = useState("");
  useEffect(() => {
    var userData = JSON.parse(localStorage.getItem("userData"));
    if (userData === null) {
      props.checkLoggedIn(false);
    } else {
      axios.defaults.headers.common["Authorization"] = JSON.parse(
        localStorage.getItem("userData")
      ).token;
      axios
        .post(window.ajaxLink + "cloud_programs/exercise-search", {
          search: useSearch,
        })
        .then((res) => {
          if (res.data.responseData) {
            // let response = res.data.responseData;
            // setVirtualActs(response);
          }
        })
        .catch((error) => {
          console.error(error);
          if (
            error.response.data.responseCode === 400 ||
            error.response.data.responseCode === 401
          ) {
            props.checkLoggedIn(false);
          }
        });
    }
  }, [useSearch, setUseSearch, props]);

  const numericOptsHold = (valNum, sym) => {
    let valArr = [];
    var noHold = { value: "No Hold" };
    valArr.push(noHold);
    var i = 4;
    if (sym === "%") {
      i = 0;
    }

    for (i; i <= valNum; i++) {
      var valObj = { value: i + (sym ? sym : "") };
      valArr.push(valObj);
    }
    return valArr;
  };

  const numericOptsDuration = (valNum, sym) => {
    let valArr = [];
    var i = 1;
    if (sym === "%") {
      i = 0;
    }

    for (i; i <= valNum; i++) {
      var valObj = { value: i + (sym ? sym : "") };
      valArr.push(valObj);
    }
    return valArr;
  };

  //const [optionsPercentage] = useState(numericOpts(100, "%"));
  const percentageArr = Array.from({ length: 7 }, (_, index) => ({
    value: `${40 + index * 10}%`,
  }));
  const [maxRom] = useState(percentageArr);

  const setMaxMinROM = (lowest) => {
    var retArray = [];
    for (var i = lowest; i <= 100; i += 10) {
      retArray.push({ value: i + "%" });
    }
    return retArray;
  };

  const setLimb = (limbs) => {
    var retArray = [];
    limbs.forEach((itm) => {
		retArray.push({ value: itm.name });
	});
    return retArray;
  };

  const [optionsPlainNumsReps] = useState(numericOptsDuration(30));
  const [optionsPlainNums] = useState(numericOptsHold(60));
  // eslint-disable-next-line
  const [optionsMinutes] = useState(numericOptsDuration(120, " min"));

  // let totalNum = (function () {
  //   var totalValue = 0;
  //   for (var item of activityPool) {
  //     if (item.duration_type === "Reps") {
  //       totalValue = totalValue + item.duration * item.reps;
  //     } else {
  //       totalValue = totalValue + item.duration;
  //     }
  //   }
  //   return totalValue;
  // })();

  // const [exrSelected, setExrSelected] = useState(0);
  // const [vtNameSelected, setVtNameSelected] = useState(0);
  // const [exrName, setExrName] = useState("");
  // const [isTimeSelected, setTimeSelected] = useState(false);
  // const [repsNum, setRepsNum] = useState(false);
  // const [minuteSelected, setMinutes] = useState(0);
  // const [secondsSelected, setSeconds] = useState(0);
  // const [videoSelected, setVideoSelected] = useState("");

  const updateActDets = (valueSet, value) => {
    if (dayInx && taskInx) {
      localStorage.setItem("ExerBuilderEdited", true);
    }
    if (value === "No Hold") {
      value = "0";
    }
    var actArr = [...activityPool];
    if (!isNaN(value)) {
      value = parseInt(value);
    }
    actArr[valueSet[0]][valueSet[1]] = value;

    var sumTime = 0;
    for (var oneTime of actArr) {
      let sumReps1 = 0;
      let sumReps2 = 0;

      if (oneTime.hold_in_seconds > 0) {
        sumReps1 += oneTime.reps;
        sumTime += sumReps1 * (oneTime.hold_in_seconds + 5);
      } else {
        sumReps2 += oneTime.reps;
        sumTime += sumReps2 * 5;
      }
    }

    setWorkoutDuration(Math.ceil(sumTime / 60));
    setActivityPool(actArr);
  };

  const [exrCollectionOpen, setExrCollectionOpen] = useState(false);
  const openUpExrCollection = () => {
    setExrCollectionOpen(true);
  };

  const [exerciseCollection, setExerciseCollection] = useState([]);
  const handleExrSelection = (inx) => {
    var exrs = [...exerciseCollection];
    exrs[inx].checked = !exrs[inx].checked;
    addExrToOrder(exrs[inx], exrs[inx].checked, inx);
    setExerciseCollection(exrs);
  };

  const [eqIds, setEqIds] = useState([]);

  useEffect(() => {
    var exers = [];

    for (var exerc of exerciseCollection) {
      if (exerc.exercise_data.hold_in_seconds === 0) {
        exers.push(exerc.exercise_data.equipment_id);
      }
      setEqIds(exers); //exercise ids that has 0 hold in sec
    }
  }, [exerciseCollection]);

  const addOrRemoveSets = (inx, mod) => {
    var exrs = [...exerciseCollection];
    if (mod === "add") {
      exrs[inx].multiple_sets++;
    } else if (mod === "substract" && exrs[inx].multiple_sets - 1 > 0) {
      exrs[inx].multiple_sets--;
    }
    setExerciseCollection(exrs);
  };

  const [collectSearch, setCollectSearch] = useState("");
  const searchExr = useRef("");
  const updateCollectSearch = (value) => {
    setCollectSearch(value.trim());
  };
  useEffect(() => {
    axios.defaults.headers.common["Authorization"] = JSON.parse(
      localStorage.getItem("userData")
    ).token;
    axios
      .post(window.ajaxLink + "cloud_programs/get-exercise-templates", {
        search: "",
		problemId: localStorage.getItem('programDataEdit') ? JSON.parse(localStorage.getItem('programDataEdit')).problem_id || 1 : 1,
		isROM: localStorage.getItem("exerBuilderTaskType") ? 1 : 0,
        exerciseData: exerciseCollection.filter(
          (item) => item.checked === true
        ),
      })
      .then((res) => {
        if (res.data.responseData) {
          let response = res.data.responseData.exerciseData;
          const sort = response.sort((a, b) => a.is_portrait - b.is_portrait);

          sort.sort((a, b) => {
            if (b.is_portrait > a.is_portrait) {
              return -1;
            } else if (b.is_portrait < a.is_portrait) {
              return 1;
            } else {
              return a.name.localeCompare(b.name);
            }
          });
          
		  setExerciseCollection(response);
		  
		  // If ROM Test
			  setTimeout(() => {
				  if ( localStorage.getItem("exerBuilderTaskType") && !hasTasks ) {
					var exrs = [...response];
					var eOrder = [...exrOrdered];
					for ( var inx in exrs ) {
						exrs[inx].checked = true;
						exrs[inx].inxIdent = inx;
						eOrder.push(exrs[inx]);
					}
					setExrOrdered(eOrder);
					setExerciseCollection(exrs);
					insertNewActs(eOrder);
				  }
			  }, 1000);
        }
      })
      .catch((error) => {
        console.error(error);
      });
    // eslint-disable-next-line
  }, [exrCollectionOpen]);

  const [subProblemFilter, setSubProblemFilter] = useState(["Show All"]);
  const [typeFilter, setTypeFilter] = useState(["Show All"]);
  const [difficultyFilter, setDifficultyFilter] = useState(["Show All"]);
  const [levelFilter, setLevelFilter] = useState(["Show All"]);

  const countChildren = useRef(null);
  const [shownChildren, setShownChildren] = useState(null);
  const [exrOrdered, setExrOrdered] = useState([]);

  const addExrToOrder = (obj, add, inxIdent) => {
    var eOrder = [...exrOrdered];
    if (add) {
      obj.inxIdent = inxIdent;
      eOrder.push(obj);
    } else {
      var remInx = 0;
      for (var exr of eOrder) {
        if (exr.inxIdent === inxIdent) {
          eOrder.splice(remInx, 1);
        }
        remInx++;
      }
    }

    setExrOrdered(eOrder);
  };

  const [disablePortreit, setDisablePortreit] = useState(false);
  const [disableLandscape, setDisableLandscape] = useState(false);

  useEffect(() => {
    if ((disablePortreit || disableLandscape) && exrCollectionOpen) {
      setErrorPopUp(
        "For an optimal patient experience Virdio Health, requires your PT session includes all Floor exercises  than Standing or Sitting exercises, or vice versa."
      );
    }
  }, [disablePortreit, disableLandscape, exrCollectionOpen]);

  useEffect(() => {
    if (activityPool?.length < 1) {
      if (exrOrdered?.length > 1) {
        let isInArrPortreit = exrOrdered.some((obj) => obj.is_portrait === 1);
        let isInArrLandscape = exrOrdered.some((obj) => obj.is_portrait === 0);

        if (exrOrdered[0]?.is_portrait === 1 && isInArrLandscape === true) {
          setDisablePortreit(true);
        } else if (
          exrOrdered[0]?.is_portrait === 0 &&
          isInArrPortreit === true
        ) {
          setDisableLandscape(true);
        } else if (
          exrOrdered[0]?.is_portrait === 1 &&
          isInArrLandscape === false
        ) {
          setDisablePortreit(false);
          setDisableLandscape(false);
        } else if (
          exrOrdered[0]?.is_portrait === 0 &&
          isInArrPortreit === false
        ) {
          setDisableLandscape(false);
          setDisablePortreit(false);
        }
      } else {
        setDisablePortreit(false);
        setDisableLandscape(false);
      }
    } else {
      let isInPoolPortreit = activityPool.some((obj) => obj.is_portrait === 1);
      let isInPoolLandscape = activityPool.some((obj) => obj.is_portrait === 0);

      let isInOrderedPortreit = exrOrdered.some((obj) => obj.is_portrait === 1);
      let isInOrderedLandscape = exrOrdered.some(
        (obj) => obj.is_portrait === 0
      );

      if (activityPool?.length >= 1) {
        if (activityPool[0]?.is_portrait === 1 && isInPoolLandscape === true) {
          setDisablePortreit(true);
          setDisableLandscape(false);
        } else if (
          activityPool[0]?.is_portrait === 0 &&
          isInPoolPortreit === true
        ) {
          setDisableLandscape(true);
        } else if (
          activityPool[0]?.is_portrait === 1 &&
          isInPoolLandscape === false
        ) {
          setDisablePortreit(false);
          setDisableLandscape(false);

          if (isInOrderedLandscape) {
            setDisablePortreit(true);
          }
        } else if (
          activityPool[0]?.is_portrait === 0 &&
          isInPoolPortreit === false
        ) {
          setDisableLandscape(false);
          setDisablePortreit(false);

          if (isInOrderedPortreit) {
            setDisableLandscape(true);
          }
        }
      } else {
        setDisablePortreit(false);
        setDisableLandscape(false);
      }
    }
  }, [activityPool, exrOrdered]);

  useEffect(() => {
    if (countChildren.current !== null) {
      var shown = 0;
      for (var child of countChildren.current.childNodes) {
        if (
          child.classList.value.split(" ")[1] !== "exr_coll_hidden" &&
          child.classList.value !== "exr_empty" &&
          child.classList.value !== "exr_card_desc"
        ) {
          shown++;
        }
      }
      setShownChildren(shown);
    }
  }, [
    subProblemFilter,
    typeFilter,
    difficultyFilter,
    levelFilter,
    exerciseCollection,
    collectSearch,
  ]);
  const handleFilters = (arrayOfFilters, selectedOption) => {
    var arrData = [];
    for (var option of arrayOfFilters) {
      arrData.push(option.value);
    }
    selectedOption(arrData);
  };

  const addDismiss = (isSave) => {
    if (isSave) {
      insertNewActs();
    }
    var exrs = [...exerciseCollection];
    for (var exr of exrs) {
      exr.checked = false;
    }
    setSubProblemFilter(["Show All"]);
    setTypeFilter(["Show All"]);
    setDifficultyFilter(["Show All"]);
    setLevelFilter(["Show All"]);
    setCollectSearch("");

    setExerciseCollection(exrs);
    setExrCollectionOpen(false);
    setExrOrdered([]);

    if (activityPool?.length < 1) {
      setDisablePortreit(false);
      setDisableLandscape(false);
    }
  };

  const insertNewActs = (cusOrder) => {
    if (dayInx && taskInx) {
      localStorage.setItem("ExerBuilderEdited", true);
    }
	
	let doAdded = cusOrder ? cusOrder : exrOrdered;
	
    var actArr = [...activityPool];
    for (var exercise of doAdded) {
      for (var i = 0; i < exercise.multiple_sets; i++) {
        actArr.push({
          equipment_id: exercise.exercise_data.equipment_id,
          equipment_name: exercise.exercise_data.equipment_name,
          display_name: exercise.exercise_data.display_name,
          reps: exercise.exercise_data.reps,
          hold_in_seconds: exercise.exercise_data.hold_in_seconds,
          duration_type: exercise.exercise_data.duration_type,
          duration: exercise.exercise_data.duration,
          video: exercise.exercise_data.video,
          image: exercise.exercise_data.image,
          is_portrait: exercise.is_portrait,
          have_rom: exercise.have_rom,
          limb_instructions: exercise.limb_instructions,
          rom_minimum: exercise.rom_minimum,
          target_rom_max: "100%",
          set_limb_instruction: '',
          is_complete: 0,
        });
      }
    }

    for (var exr of exerciseCollection) {
      exr.checked = false;
    }

    var sumTime = 0;
    for (var oneTime of actArr) {
      let sumReps1 = 0;
      let sumReps2 = 0;

      if (oneTime.hold_in_seconds > 0) {
        sumReps1 += oneTime.reps;
        sumTime += sumReps1 * (oneTime.hold_in_seconds + 5);
      } else {
        sumReps2 += oneTime.reps;
        sumTime += sumReps2 * 5;
      }
    }
    setWorkoutDuration(Math.ceil(sumTime / 60));
    setExrOrdered([]);
    setActivityPool(actArr);
    setUseSearch("");
  };

  const [arrToDelete, setArrToDelete] = useState(-1);
  const [isOpenDelete, setOpenDelete] = useState(false);

  const openCloseDelete = (item) => {
    setOpenDelete(!isOpenDelete);
    setArrToDelete(item);
  };

  const dltDismiss = (doConfirm) => {
    if (dayInx && taskInx) {
      localStorage.setItem("ExerBuilderEdited", true);
    }
    if (doConfirm) {
      let targetPlace = [...activityPool];
      //var activity_id = targetPlace[arrToDelete].act_id;
      targetPlace.splice(arrToDelete, 1);

      var sumTime = 0;
      for (var oneTime of targetPlace) {
        let sumReps1 = 0;
        let sumReps2 = 0;

        if (oneTime.hold_in_seconds > 0) {
          sumReps1 += oneTime.reps;
          sumTime += sumReps1 * (oneTime.hold_in_seconds + 5);
        } else {
          sumReps2 += oneTime.reps;
          sumTime += sumReps2 * 5;
        }
      }

      setWorkoutDuration(Math.ceil(sumTime / 60));
      setActivityPool(targetPlace);

      /* if (activity_id) {
        axios.defaults.headers.common["Authorization"] = JSON.parse(localStorage.getItem("userData")).token;
        axios
          .post(window.ajaxLink + "cloud_programs/delete-activity", {
            activity_id,
            task_id,
            duration: Math.ceil(sumTime / 60),
          })
          .then(() => {
            var deletedActArr = [];
            if (localStorage.getItem("deleted_activities") !== null) {
              deletedActArr = JSON.parse(localStorage.getItem("deleted_activities"));
            }
            deletedActArr.push(activity_id);
            localStorage.setItem("deleted_activities", JSON.stringify(deletedActArr));
          })
          .catch((error) => {
            console.log(error);
          });
      } */
    }
    setOpenDelete(false);
    setArrToDelete(-1);
  };

  const [isOpenVideo, setOpenVideo] = useState(false);
  const [previewItem, setPreviewItem] = useState("");
  const [previewTitle, setPreviewTitle] = useState("");

  const openCloseVideo = (item, title) => {
    setOpenVideo(!isOpenVideo);
    setPreviewItem(item);
    setPreviewTitle(title);
  };

  const exrMove = (inx, upOrDn) => {
    if (dayInx && taskInx) {
      localStorage.setItem("ExerBuilderEdited", true);
    }
    let targetPlace = [...activityPool];
    if (inx + upOrDn === -1 || inx + upOrDn === targetPlace.length) {
      return false;
    }

    if (targetPlace[inx + upOrDn].is_complete === 1) {
      return false;
    }

    let newObj = { ...targetPlace[inx] };
    let tempId = newObj.act_id;
    let newObj2 = { ...targetPlace[inx + upOrDn] };

    newObj.act_id = newObj2.act_id;
    newObj2.act_id = tempId;
    targetPlace[inx] = newObj2;
    targetPlace[inx + upOrDn] = newObj;
    setActivityPool(targetPlace);
  };

  const exrDuplicate = (inx) => {
    if (dayInx && taskInx) {
      localStorage.setItem("ExerBuilderEdited", true);
    }
    let targetPlace = [...activityPool];
    let newObj = { ...targetPlace[inx] };
    delete newObj.activity_id;
    targetPlace.push(newObj);
    setActivityPool(targetPlace);

    var sumTime = 0;
    for (var oneTime of targetPlace) {
      let sumReps1 = 0;
      let sumReps2 = 0;

      if (oneTime.hold_in_seconds > 0) {
        sumReps1 += oneTime.reps;
        sumTime += sumReps1 * (oneTime.hold_in_seconds + 5);
      } else {
        sumReps2 += oneTime.reps;
        sumTime += sumReps2 * 5;
      }

      if (!oneTime.activity_id) {
        oneTime.is_complete = 0;
      }
    }

    setWorkoutDuration(Math.ceil(sumTime / 60));
  };

  const [errorPopUp, setErrorPopUp] = useState("");
  const popupRef = useRef(errorPopUp);
  useEffect(() => {
    popupRef.current = errorPopUp;
    const timeout = setTimeout(() => {
      setErrorPopUp("");
    }, 6000);
    return () => {
      clearTimeout(timeout);
    };
  }, [errorPopUp]);
  const [errorInputs, setErrorInputs] = useState(false);

  const saveEditChanges = () => {
    localStorage.removeItem("ExerBuilderEdited");
    setSaveExerciseBuilder(false);
    var progEdit = JSON.parse(localStorage.getItem("programDataEdit"));
    setErrorPopUp("");
    setErrorInputs(false);

    if (
      !workoutName ||
      workoutName.trim() === "" /* || !workoutLevel  || !workoutDuration */
    ) {
      setErrorPopUp("Please fill in all the marked fields.");
      setErrorInputs(true);
      return false;
    }

    if (workoutName === "New PT Session") {
      setErrorPopUp("Invalid PT session name, try different name.");
      setErrorInputs(true);
      return false;
    }

    if (activityPool && activityPool.length === 0) {
      setErrorPopUp("Please add at least one Exercise.");
      return false;
    }
    for (var singleActivity of activityPool) {
      if (
        /* !singleActivity.equipment_name || */ !singleActivity.display_name ||
        !singleActivity.reps
      ) {
        setErrorPopUp("Please fill in all the marked fields.");
        setErrorInputs(true);
        return false;
      }
    }

    /*  if (task_id) {
      axios.defaults.headers.common["Authorization"] = JSON.parse(localStorage.getItem("userData")).token;
      axios
        .post(window.ajaxLink + "cloud_programs/save-task-activities", {
          task_id,
          workoutName,
          workoutDesc,
          workoutLevel,
          workoutRom,
          workoutDuration,
          activityPool,
        })
        .then((res) => {
          if (res.data.responseData) {
            let response = res.data.responseData;
            if (response.activities || response.message === "success") {
              if (response.activities !== undefined && response.activities.length > 0) {
                var actArr = JSON.parse(localStorage.getItem("inserted_activities")) || [];
                for (var responseId of response.activities) {
                  actArr.push(responseId);
                }
                localStorage.setItem("inserted_activities", JSON.stringify(actArr));
                localStorage.removeItem("is_edit_template");
              }
              navigate("/protocols/" + sendBackParam + "/edit");
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } else { */
    let existingData = JSON.parse(localStorage.getItem("new_tasks"));

    var allData = {
      dayInx,
      taskInx,
      workoutName,
      workoutDesc,
      workoutLevel,
      workoutRom,
      workoutDuration,
      activityPool,
    };
    if (existingData) {
      let sameSpot = existingData.indexOf(
        existingData.filter(
          (obj) => obj.dayInx === dayInx && obj.taskInx === taskInx
        )[0]
      );

      if (sameSpot > -1) {
        existingData[sameSpot] = allData;
      } else {
        existingData.push(allData);
      }
      localStorage.setItem("new_tasks", JSON.stringify(existingData));
    } else {
      let dataNew = [];
      dataNew.push(allData);
      localStorage.setItem("new_tasks", JSON.stringify(dataNew));
    }

    var toChange = { ...progEdit };

    var newActArr = [];
    for (var activity of activityPool) {
      var newActObj = {
        display_name: activity.display_name,
        duration: activity.duration,
        duration_type: activity.duration_type,
        equipment_id: activity.equipment_id,
        equipment_name: activity.equipment_name,
        hold_in_seconds: activity.hold_in_seconds,
        image: activity.image,
        reps: activity.reps,
        video: activity.video,
      };
      newActArr.push(newActObj);
    }

    toChange.day_data[dayInx].tasks_arr[taskInx].duration = workoutDuration;
    toChange.day_data[dayInx].tasks_arr[taskInx].exercise_number =
      activityPool.length;
    toChange.day_data[dayInx].tasks_arr[taskInx].task_name = workoutName;
    toChange.day_data[dayInx].tasks_arr[taskInx].activity_data = newActArr;

    localStorage.setItem("programDataEdit", JSON.stringify(toChange));
    localStorage.removeItem("exerBuilderTaskType");

    navigate(
      programId
        ? "/protocols/" + programId + "/edit"
        : "/" +
            (localStorage.getItem("prev_link")
              ? localStorage.getItem("prev_link")
              : "newtemplate")
    );
    /*  } */
    localStorage.setItem("fromExerBuilder", true);
  };

  const [isExitOpen, setExitOpen] = useState(false);
  const handleExit = (confirmSave) => {
    if (
      !workoutLevel &&
      !workoutDesc /* && !workoutDuration */ &&
      activityPool.length === 0
    ) {
      navigate(
        programId
          ? "/protocols/" + programId + "/edit"
          : "/" +
              (localStorage.getItem("prev_link")
                ? localStorage.getItem("prev_link")
                : "newtemplate")
      );
    }

    if (
      workoutName !== workoutNameCopy ||
      workoutDesc !== workoutDescCopy ||
      workoutLevel !== workoutLevelCopy ||
      workoutRom !== workoutRomCopy ||
      /* workoutDuration !== workoutDurationCopy || */
      JSON.stringify(activityPool) !== activityPoolCopy
    ) {
      setExitOpen(!isExitOpen);
    } else {
      navigate(
        programId
          ? "/protocols/" + programId + "/edit"
          : "/" +
              (localStorage.getItem("prev_link")
                ? localStorage.getItem("prev_link")
                : "newtemplate")
      );
    }

    if (confirmSave) {
      saveEditChanges();
    }
  };

  const validateInput = (input) => {
    const regex = /^[a-zA-Z0-9 .,?!]*$/;
    return regex.test(input);
  };

  const updateWorkoutsData = (paramToChange, value) => {
    if (dayInx && taskInx) {
      localStorage.setItem("ExerBuilderEdited", true);
    }
    const valid = validateInput(value);
    if (!valid) {
      setErrorPopUp(
        "Invalid input: only letters, numbers, spaces, and standard punctuation are allowed."
      );
      return;
    }

    if (paramToChange === "workout_name") {
      setWorkoutName(value);
    }

    if (paramToChange === "workout_desc") {
      setWorkoutDesc(value);
    }
  };

  // _______________ CANCEL BUTTON FUNCTIONS _______________________________

  const [
    programNameEditWithoutSavingModal,
    setProgramNameEditWithoutSavingModal,
  ] = useState(false);

  const fromExerBuilder = (param) => {
    if (param === "edit") {
      navigate("/protocols/" + programId + "/edit");
      localStorage.setItem("fromExerBuilder", true);
    } else if (param === "new") {
      navigate("/newtemplate");
      localStorage.setItem("fromExerBuilder", true);
    }
  };

  const handleProgramNameModalClick = () => {
    if (localStorage.getItem("ExerBuilderEdited")) {
      setProgramNameEditWithoutSavingModal(true);
    } else {
      fromExerBuilder(localStorage.getItem("taskBuilderType"));
      localStorage.removeItem("ExerBuilderEdited");
    }
  };

  const handleProgramNameModalClose = () => {
    setProgramNameEditWithoutSavingModal(false);
  };

  const handleProgramNameYes = () => {
    fromExerBuilder(localStorage.getItem("taskBuilderType"));
    localStorage.removeItem("ExerBuilderEdited");
  };

  const handleProgramNameNo = () => {
    saveEditChanges();
  };

  useEffect(() => {
    if(saveExerciseBuilder){
      saveEditChanges();
    }
  }, [saveExerciseBuilder])

  hasTasks = activityPool.length > 0;

  return (
    <div id="exr_bld">
      <div onClick={() => localStorage.removeItem("exerBuilderTaskType")}>
        <Breadcrumbs
          taskInx={taskInx}
          dayInx={dayInx}
          task_id={task_id}
          workoutName={workoutName}
        ></Breadcrumbs>
      </div>
      <div className="prog_dets_title_and_btn_holder">
        <div className="new_workout_title_and_btn_holder">
          <div className="new_workout_title">
            {localStorage.getItem("exerBuilderTaskType")
              ? "New Range of Motion Test"
              : "New PT Session"}
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              gap: "10px",
              alignItems: "center",
            }}
          >
            {dayInx && taskInx && localStorage.getItem("taskBuilderType") && (
              <div
                className="prog_edit_btn prog_edit_invert prog_det_new_btn_left"
                onClick={handleProgramNameModalClick}
              >
                Cancel
              </div>
            )}
            <div
              style={{ width: "max-content" }}
              className={
                "prog_edit_btn prog_save_btn" +
                (localStorage.getItem("exerBuilderTaskType")
                  ? " prog_save_rtest"
                  : "")
              }
              onClick={() => saveEditChanges()}
            >
              Save{" "}
              {localStorage.getItem("exerBuilderTaskType")
                ? "Range of Motion Test"
                : "PT Session"}
            </div>
          </div>
        </div>
      </div>
      <div className="prog_det_top_hold builder_row_container">
        {/* <div className="prog_det_back prog_back_text">
          {task_id > 0 ? (
            <>
              <div className="prog_back_icon"></div>
              <div className="prog_det_back_text prog_back_align" onClick={() => handleExit()}>
                Back to Recovery Plan Details
              </div>
            </>
          ) : (
            <>
              <div className="prog_back_icon"></div>
              <div className="prog_det_back_text prog_back_align" onClick={() => handleExit()}>
                Back to {localStorage.getItem("prev_link") === "newtemplate" ? "Recovery Plan" : "Protocol"} Details
              </div>
            </>
          )}
        </div> */}
        <div className="e_build_main_title">
          <div
            className={
              "eb_main_input_hold" +
              (errorInputs && (!workoutName || workoutName === "New PT Session")
                ? " prog_err_input"
                : "")
            }
          >
            <div
              className={
                workoutName && workoutName.length > 0
                  ? "select_main"
                  : "select_main select_active_length"
              }
            >
              {workoutName && workoutName.length > 0 && (
                <div className="select_placeholder sp_act">
                  {localStorage.getItem("exerBuilderTaskType")
                    ? "Range of Motion Test"
                    : "PT Session"}{" "}
                  Name (Max 30 Characters)
                </div>
              )}
              <div>
                <input
                  className="select_main_name"
                  type="text"
                  maxLength={30}
                  value={workoutName}
                  placeholder={
                    localStorage.getItem("exerBuilderTaskType")
                      ? "Range of Motion Test"
                      : "PT Session Name"
                  }
                  onChange={(e) =>
                    updateWorkoutsData("workout_name", e.target.value)
                  }
                />
              </div>
            </div>
          </div>
          {/* <div className="eb_upper_selects">
            <div className="eb_main_select_hold eb_select_lvl">
              <Select
                initVal={workoutLevel}
                placeholder={"Level"}
                selectOptions={taskLevels}
                callBackValue={setWorkoutLevel}
                selectCallback={updateWorkoutLevel}
                selectError={!workoutLevel && errorInputs}
                inExerciseBuild={true}
              />
            </div> 
            {/*        
            <div className="eb_main_select_hold">
              <Select
                initVal={workoutRom}
                placeholder={"ROM%"}
                selectOptions={optionsPercentage}
                callBackValue={setWorkoutRom}
                selectCallback={updateWorkoutLevel}
                selectError={!workoutRom && errorInputs}
              />
            </div>
            {/* <div className="eb_main_select_hold eb_select_lvl eb_upper_last">
              <Select
                initVal={workoutDuration}
                placeholder={"Duration"}
                selectOptions={optionsMinutes}
                callBackValue={setWorkoutDuration}
                selectCallback={updateWorkoutLevel}
                selectError={!workoutDuration && errorInputs}
              />
            </div>
          </div>*/}
        </div>
        <div className="e_build_description">
          <div className="eb_main_input_hold eb_input_large">
            <div className="select_main">
              <div className="select_placeholder sp_act">
                {workoutDesc.length > 0
                  ? "Description (Max 250 Characters)"
                  : "Enter Description..."}
              </div>
              <textarea
                value={workoutDesc}
                maxLength={250}
                onChange={(e) =>
                  updateWorkoutsData("workout_desc", e.target.value)
                }
              ></textarea>
            </div>
          </div>
        </div>
      </div>
      <div className="eb_margin_set">
        {activityPool.length >= 0 &&
        exerciseCollection &&
        exerciseCollection.length > 0 ? (
          <div
            className={activityPool.length > 0 ? "e_build_activities_hold" : ""}
            style={{ marginBottom: "140px" }}
          >
            {/* {          <div className="e_build_upper_create">
            <div className="e_create_options_hold">
              <div className="e_create_option">
                <div className="eb_single_opt_title">Exercise</div>
                <div className="eb_select_wrap"></div>
              </div>
              <div className="e_create_option">
                <div className="eb_single_opt_title">
                  Exercise Name (Max 30 Characters)
                </div>
                <div className="eb_select_wrap">
                  <input
                    type="text"
                    className="e_create_input select_main"
                    onChange={(e) => setExrName(e.currentTarget.value)}
                  />
                </div>
              </div>
              <div className="e_create_option">
                <div className="eb_single_opt_title eb_opt_short_title">
                  Duration Type
                </div>
                <div className="eb_single_opt_title eb_opt_short_title">
                  {isTimeSelected ? "" : "# of reps"}
                </div>
                <div className="eb_option_short">
                  <div className="eb_select_wrap eb_sel_short_wrap">
                    <Select
                      initVal={"Reps"}
                      selectOptions={durationTypes}
                      callBackValue={setTimeSelected}
                      selectCallback={function (callVal, value) {
                        if (value === "Time") {
                          callVal(true);
                        } else {
                          callVal(false);
                        }
                      }}
                    />
                  </div>
                  <div className="eb_select_wrap eb_sel_short_wrap">
                    {isTimeSelected ? (
                      <Select
                        initVal={"Minutes"}
                        selectOptions={optionSets}
                        callBackValue={setMinutes}
                        selectCallback={function (callVal, value) {
                          callVal(value);
                        }}
                      />
                    ) : (
                      <input
                        type="text"
                        className="e_create_input select_main"
                        onChange={(e) =>
                          checkForNumber(e.currentTarget.value, setRepsNum)
                        }
                      />
                    )}
                  </div>
                  <div className="eb_select_wrap eb_sel_short_wrap">
                    <Select
                      initVal={"Seconds"}
                      selectOptions={optionSets}
                      callBackValue={setSeconds}
                      selectCallback={function (callVal, value) {
                        callVal(value);
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>} */}
            <div
              className={activityPool.length > 0 ? "table_title_minwidth" : ""}
            >
              {activityPool.length > 0 && (
                <div className="e_build_single_act e_build_act_desc">
                  <div className="eb_single_option eb_so_title eb_so_largest">
                    Exercise Name
                  </div>
                  <div className="eb_single_option eb_so_title eb_so_mid eb_so_mid_smaller">
                    Reps
                  </div>
                  <div className="eb_single_option eb_so_title eb_so_mid">
                    Hold in seconds
                  </div>
                  <div className="eb_single_option eb_so_title eb_so_mid eb_so_mid_smaller">
                    Max ROM
                  </div>
                  <div className="eb_single_option eb_so_title eb_so_mid eb_so_mid_smaller">
                    Instructions
                  </div>
                  <div className="eb_single_option eb_so_title eb_so_last"></div>
                </div>
              )}
              <div className="eb_overall_activity">
                {/* {<div className="eb_activity_header">
              {activityTitles.map((item, i) => (
                <div key={i} className="eb_activity_title">
                  {item.title}
                </div>
              ))}
            </div>} */}
                {activityPool.map((item, i) => (
              <ExerciseActivity 
                key={i}
                item={item}
                i={i}
                optionsPlainNumsReps={optionsPlainNumsReps}
                optionsPlainNums={optionsPlainNums}
                setMaxMinROM={setMaxMinROM}
                setLimb={setLimb}
                updateActDets={updateActDets}
                openCloseVideo={openCloseVideo}
                exrMove={exrMove}
                exrDuplicate={exrDuplicate}
                openCloseDelete={openCloseDelete}
                errorInputs={errorInputs}
                eqIds={eqIds}
                maxRom={maxRom}
              />
                ))}
              </div>
            </div>
          </div>
        ) : (
          <div className="p_load"></div>
        )}
        {/* {<div className="eb_activity_duration">
            Total Workout Duration
            {" " +
              Math.floor(totalNum / 60) +
              " min and " +
              (totalNum - Math.floor(totalNum / 60) * 60) +
              " sec"}
          </div>} */}
        {/* {<div className="e_build_exercises_hold">
          <div className="e_build_section_title">Add Exercises</div>
          {virtualActs.map((item, i) => (
            <div className="e_build_position">
              <div key={i} className="eb_single_exercise">
                <div className="eb_exr_inner">
                  <div className="eb_exr_main">
                    <div
                      className="eb_exr_image"
                      style={{ backgroundImage: "url(" + item.image + ")" }}
                    ></div>
                    <div className="eb_exr_titles_contain">
                      <div className="eb_exr_title_main">{item.name}</div>
                      <div className="eb_exr_title_sub">{item.category}</div>
                    </div>
                  </div>
                  <div className="eb_buttons eb_exr_main">
                    <div className="add_btn eb_info eb_exr_btn_marg"></div>
                    <div
                      className="add_btn add_white_bgnd eb_exr_btn_marg eb_marg_right"
                      onClick={() =>
                        insertNewAct({
                          equipment: item.name,
                          equipment_id: item.key,
                        })
                      }
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>} */}
        <div
          className="day_new_btn eb_new_tool"
          // onClick={() =>
          //   insertNewAct({
          //     equipment_id: "",
          //     equipment_name: "",
          //     display_name: "",
          //     reps: "",
          //     duration_type: "",
          //     duration: 0,
          //     video: "",
          //   })
          // }
          onClick={() => openUpExrCollection()}
        >
          <div className="dbl_info_contain">
            <div className="dbl_info">
              <div className="dbl_info_text">Add Exercise</div>
            </div>
            <div className="dbl_arrow"></div>
          </div>
        </div>
        {exrCollectionOpen && (
          <div
            className="dlt_wrapper"
            style={{
              height:
                exrPage.scrollHeight > window.innerHeight
                  ? exrPage.scrollHeight + wrapMarg + "px"
                  : 100 + "vh"
            }}
          >
            {/* <div className="approval_close exr_pick_close" onClick={() => addDismiss()}></div> */}
            <div className="eb_exr_data_hold min_popup_size" style={{width: '90%'}}>
              <div className="eb_exr_titles_hold">
                <div className="eb_exr_popup_title">Add Exercises</div>
                <div className="eb_exr_popup_subtitle">
                  {/* { Select the exercises you want to add to this workout} */}
                </div>
              </div>
              <div className="eb_exr_search_hold">
                <input
                  type="text"
                  ref={searchExr}
                  placeholder="Search"
                  className="eb_exr_search"
                  onChange={() => updateCollectSearch(searchExr.current.value)}
                />
              </div>
              <div className="eb_exr_filter_hold">
                <div className="eb_single_filter">
                  <div className="eb_filter_title">Sub-Type</div>
                  <MultiSelect
                    initVal={[{ value: "Show All" }]}
                    selectOptions={[
                      { value: "Show All" },
                      { value: "Flexion" },
                      { value: "Extension" },
                      { value: "Stenosis" },
                      { value: "Stabilization" },
                    ]}
                    selectCallback={handleFilters}
                    callBackValue={setSubProblemFilter}
                  />
                </div>
                <div className="eb_single_filter">
                  <div className="eb_filter_title">Position Category</div>
                  <MultiSelect
                    initVal={[{ value: "Show All" }]}
                    selectOptions={[
                      { value: "Show All" },
                      { value: "Floor" },
                      { value: "Seated" },
                      { value: "Standing" },
                    ]}
                    selectCallback={handleFilters}
                    callBackValue={setTypeFilter}
                  />
                </div>
                <div className="eb_single_filter">
                  <div className="eb_filter_title">Exercise Difficulty</div>
                  <MultiSelect
                    initVal={[{ value: "Show All" }]}
                    selectOptions={[
                      { value: "Show All" },
                      { value: "Level 1" },
                      { value: "Level 2" },
                      { value: "Level 3" },
                      { value: "Level 4" },
                    ]}
                    selectCallback={handleFilters}
                    callBackValue={setDifficultyFilter}
                  />
                </div>
                {/* {<div className="eb_single_filter">
                  <div className="eb_filter_title">Exercise Level</div>
                  <MultiSelect
                    initVal={[{ value: "Show All" }]}
                    selectOptions={[
                      { value: "Show All" },
                      { value: "Level 1" },
                      { value: "Level 2" },
                      { value: "Level 3" },
                      { value: "Level 4" },
                      { value: "Level 5" },
                    ]}
                    selectCallback={handleFilters}
                    callBackValue={setLevelFilter}
                  />
                </div>} */}
              </div>
              <div className="exr_card_container_parent" style={{overflow: 'auto'}}>
              <div className="exr_card_container" style={{minWidth: '1000px'}} ref={countChildren}>
                {exerciseCollection &&
                  exerciseCollection.length > 0 &&
                  shownChildren > 0 && (
                    <div className="exr_card_desc">
                      <div className="exr_card_txt_half" style={{width: 'calc(100% - 620px)'}}>
                        <div className="exr_card_desc_txt">Select</div>
                        <div className="exr_card_desc_txt">Exercise Name</div>
                      </div>
                      <div style={{ textAlign: "right", width: '620px' }} className="exr_card_txt_half">
                        <div className="exr_card_desc_txt">Position Category</div>
                        <div className="exr_card_desc_txt">To Camera</div>
                        <div className="exr_card_desc_txt">Body Position</div>
                        <div className="exr_card_desc_txt">Limb</div>
                        <div style={{width: "150px", textAlign: 'center'}} className="exr_card_desc_txt"># of Sets</div>
                      </div>
                    </div>
                  )}
                {exerciseCollection &&
                  exerciseCollection.length > 0 &&
                  exerciseCollection.map((item, i) => (
                    <div
                      className={
                        "exr_coll_card_expand" +
                        (subProblemFilter[0] !== "Show All" &&
                        subProblemFilter.indexOf(
                          item.exercise_data.sub_problem_name
                        ) === -1
                          ? " exr_coll_hidden"
                          : typeFilter[0] !== "Show All" &&
                            typeFilter.indexOf(
                              item?.exercise_position
                              ? 
                              item?.exercise_position : 
                              item.is_portrait === 0
                              ? "Floor"
                              : item.name.split(" ")[0] === "Seated"
                              ? "Seated"
                              : "Standing"
                            ) === -1
                          ? " exr_coll_hidden"
                          : difficultyFilter[0] !== "Show All" &&
                            difficultyFilter.indexOf(
                              item.exercise_data.exercise_level
                            ) === -1
                          ? " exr_coll_hidden"
                          : levelFilter[0] !== "Show All" &&
                            levelFilter.indexOf(
                              item.exercise_data.exercise_level
                            ) === -1
                          ? " exr_coll_hidden"
                          : collectSearch.length > 0 &&
                            item.name
                              .toLowerCase()
                              .indexOf(collectSearch.toLowerCase()) === -1
                          ? " exr_coll_hidden"
                          : "")
                      }
                    >
                      <div
                        className={
                          "exr_coll_card" +
                          (item.checked ? " exr_coll_card_selected" : "") +
                          " " +
                          (disablePortreit &&
                          item.is_portrait === 1 &&
                          !item.checked
                            ? " pst_last_disabled_no_op"
                            : disableLandscape &&
                              item.is_portrait === 0 &&
                              !item.checked
                            ? " pst_last_disabled_no_op"
                            : "")
                        }
                        style={{height: "45px"}}
                        onClick={() => handleExrSelection(i)}
                      >
                        <div className="exr_coll_half left_exr_coll" 
                         style={{width: 'calc(100% - 604px)'}}>
                          <div
                            className={
                              "exr_coll_check" +
                              (item.checked ? " exr_coll_checked" : "")
                            }
                          ></div>
                          <div
                            className="exr_coll_image_frame exr_image"
                            style={{
                              backgroundImage: `url(${item.image})`,
                            }}
                          ></div>
                          <div
                            className="exr_coll_title"
                            title={item.name}
                          >
                            {item.name}
                          </div>
                        </div>
                        <div className="exr_card_txt_half" style={{ textAlign: "right", width: '604px', height: "max-content"}}>
                        <div className="exr_card_desc_txt exr_coll_title" style={{marginTop: "12px"}}>
                            {
                              item?.exercise_position
                              ? 
                              `${item?.exercise_position}` : 
                              item.is_portrait === 0
                              ? "Floor"
                              : item.name.split(" ")[0] === "Seated"
                              ? "Sitting"
                              : "Standing"
                            }
                        </div>
                        <div className="exr_card_desc_txt exr_coll_title" style={{marginTop: "12px"}}>
                            At Camera
                        </div>
                        <div className="exr_card_desc_txt exr_coll_title" style={{marginTop: "12px"}}>
                            Facing Right
                        </div>
                        <div className="exr_card_desc_txt exr_coll_title" style={{marginTop: "12px"}}>
                            { item?.limb_instructions?.length > 0 ? 'Y' : 'N' }
                        </div>
						
                        <div className="exr_card_desc_txt exr_coll_half right_exr_coll" style={{width: "134px", textAlign: 'center'}} >
                          {/* {item.checked && ( */}
                            <div
                            style={item.checked ? {} : {visibility: "hidden"}}
                              className={
                                "exr_coll_selector" +
                                (!item.checked
                                  ? " exr_coll_select_disabled"
                                  : "")
                              }
                              onClick={(e) => e.stopPropagation()}
                            >
                              <div
                                className={
                                  "exr_coll_change exr_coll_add" +
                                  (!item.checked
                                    ? " exr_coll_add_disabled"
                                    : "")
                                }
                                onClick={() =>
                                  item.checked
                                    ? addOrRemoveSets(i, "substract")
                                    : ""
                                }
                              ></div>
                              {item.multiple_sets}
                              <div
                                className={
                                  "exr_coll_change exr_coll_substract" +
                                  (!item.checked
                                    ? " exr_coll_sub_disabled"
                                    : "")
                                }
                                onClick={() =>
                                  item.checked ? addOrRemoveSets(i, "add") : ""
                                }
                              ></div>
                            </div>
                          {/* )} */}
                        </div>
                        </div>
                      </div>
                    </div>
                  ))}
                {(exerciseCollection.length === 0 || shownChildren === 0) && (
                  <div className="exr_empty">No exercises found.</div>
                )}
              </div>
              </div>
              <div className="exr_button_hold">
                <div className="exr_coll_button" onClick={() => addDismiss()}>
                  Cancel
                </div>
                <div
                  className={
                    "exr_coll_button exr_button_affirm" +
                    (exerciseCollection.filter((obj) => obj.checked === true)
                      .length === 0
                      ? " exr_affirm_disabled"
                      : "")
                  }
                  onClick={() =>
                    exerciseCollection.filter((obj) => obj.checked === true)
                      .length > 0
                      ? addDismiss(true)
                      : ""
                  }
                >
                  Continue
                </div>
              </div>
            </div>
          </div>
        )}
        {isOpenDelete && (
          <>
            <div className="dlt_wrapper">
              <div className="dbl_place_on_page">
                <Delete isActivity={true} dltDismiss={dltDismiss} />
              </div>
            </div>
          </>
        )}
        {isOpenVideo && (
          <div
            className="dlt_wrapper"
            style={{
              height:
                exrPage.scrollHeight > window.innerHeight
                  ? exrPage.scrollHeight + wrapMarg + "px"
                  : 100 + "vh",
            }}
          >
            <div className="vt_place_on_page">
              <VideoPlayer
                previewItem={previewItem}
                previewTitle={previewTitle}
                vtDismiss={openCloseVideo}
              />
            </div>
          </div>
        )}
        {isExitOpen && (
          <div className="dlt_wrapper">
            <div className="dbl_place_on_page">
              <div className="exit_surround">
                <div className="exit_primary_title">
                  Are you sure you want to exit?
                </div>
                <div className="exit_explain">
                  If you exit now your changes will be lost. Save your changes
                  before exiting.
                </div>
                <div className="exit_btn_hold">
                  <div
                    className="exit_btn exit_btn_bleak exit_new_btn_mid"
                    onClick={() => handleExit()}
                  >
                    Go back
                  </div>
                  <div
                    className="exit_btn exit_btn_bleak exit_new_btn_mid"
                    onClick={() =>
                      navigate(
                        programId
                          ? "/protocols/" + programId + "/edit"
                          : "/" +
                              (localStorage.getItem("prev_link")
                                ? localStorage.getItem("prev_link")
                                : "newtemplate")
                      )
                    }
                  >
                    Exit
                  </div>
                  {/* <div className="exit_btn exit_btn_regular" onClick={() => handleExit(true)}>
                    Save and Exit
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        )}
        {errorPopUp && (
          <div className="prog_err_hold">
            <div className="prog_err_icon"></div>
            <div className="prog_err_text">{errorPopUp}</div>
          </div>
        )}
      </div>

      <ExerciseBuilderModal
        title={"Do you want to exit without saving exercise?"}
        openModal={programNameEditWithoutSavingModal}
        handleModalClose={handleProgramNameModalClose}
        handleYes={handleProgramNameYes}
        handleNo={handleProgramNameNo}
      />
    </div>
  );
};

export default ExerciseBuilder;
